import React, { Component } from "react";
import "./SkillCard.scss";

class SkillCard extends Component {
	render() {
		return (
			<a
				href={this.props.url}
				className="skill-card card-colors"
				rel="noreferrer"
				target="_blank"
			>
				<div className="overlay"></div>
				<div className="circle">
					<img src={this.props.src} alt={this.props.value}></img>
				</div>
				<p>{this.props.value}</p>
			</a>
		);
	}
}

export default SkillCard;
